<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content" v-if="product">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Detalles</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<h4>
								<template v-if="product.reference">
									{{ product.reference }}
								</template>
								<template v-else>
									{{ $platform.setting.number_symbol }}{{ product.product_id }}
								</template>
								{{ product.title }}
							</h4>
							<div v-html="product.description"></div>
						</div>
					</div>
					<template v-if="product.attribute_storages">
						<template v-if="product.attribute_storages.length">
							<div class="row">
								<div class="col-md-12">
									<h5>Atributos</h5>
									<ul>
										<li v-for="attribute in product.attribute_storages">
											{{ attribute.name }}:
											<template v-if="attribute.product_attribute_type_field_id == 1">
												{{ attribute.value.decimal_value }}
											</template>
											<template v-if="attribute.product_attribute_type_field_id == 2">
												{{ attribute.value.integer_value }}
											</template>
											<template v-if="attribute.product_attribute_type_field_id == 3">
												{{ attribute.value.string_value }}
											</template>
											<template v-if="attribute.product_attribute_type_field_id == 4">
												<template v-if="attribute.value_lists">
													<template v-if="attribute.value_lists.length">
														[<span v-for="value_list in attribute.value_lists">
															{{ value_list.name }}
														</span>]
													</template>
												</template>
											</template>
										</li>
									</ul>
								</div>
							</div>
						</template>
					</template>
					<div class="row">
						<div class="col-md-12">
							Cantidad : {{ product.quantity }}
						</div>
						<div class="col-md-12">
							{{ product.measurement_unit.name }}: {{ product.total_measurement_unit_quantity }}
						</div>
						<div class="col-md-12">
							Base:
							<template v-if="data.provider">
								{{ product.purchase_base_price | currency }}
							</template>
							<template v-else>
								{{ product.base_price | currency }}
							</template>
						</div>
						<div class="col-md-12">
							Descuento:
							<template v-if="data.provider">
								{{ product.purchase_discount }}
							</template>
							<template v-else>
								{{ product.discount }}
							</template>
							<span v-if="product.discount">
								%
							</span>
						</div>
						<div class="col-md-12">
							Ahorro:
							<template v-if="data.provider">
								{{ product.purchase_save | currency }}
							</template>
							<template v-else>
								{{ product.save | currency }}
							</template>
						</div>
						<div class="col-md-12">
							Precio:
							<template v-if="data.provider">
								{{ product.purchase_price | currency }}
							</template>
							<template v-else>
								{{ product.price | currency }}
							</template>
						</div>
						<div class="col-md-12">
							Impuestos:
							<template v-if="data.provider">
								{{ product.purchase_taxes | currency }}
							</template>
							<template v-else>
								{{ product.taxes | currency }}
							</template>
							<template v-if="product.tax">
								({{ product.tax.value }}%)
							</template>
						</div>
						<div class="col-md-12">
							Importe:
							<template v-if="data.provider">
								{{ product.purchase_amount | currency }}
							</template>
							<template v-else>
								{{ product.amount | currency }}
							</template>
						</div>
						<template v-if="product.extras">
							<template v-if="product.extras.length">
								<div class="col-md-12">
									Extras
									<ul>
										<li v-for="extra in product.extras">
											{{ extra.name }}
											<template v-if="data.provider">
												<small>
													({{ extra.purchase_value | currency }})
												</small>
											</template>
											<template v-else>
												<small>
													({{ extra.sale_value | currency }})
												</small>
											</template>
											<br>
										</li>
									</ul>
								</div>
							</template>
						</template>
						<div class="col-md-12">
							Subtotal:
							<template v-if="data.provider">
								{{ product.purchase_total | currency }}
							</template>
							<template v-else>
								{{ product.total | currency }}
							</template>
						</div>
						<div class="col-md-12">
							Total impuestos:
							<template v-if="data.provider">
								{{ product.purchase_total_taxes | currency }}
							</template>
							<template v-else>
								{{ product.total_taxes | currency }}
							</template>
						</div>
						<div class="col-md-12">
							Total:
							<template v-if="data.provider">
								{{ product.purchase_total_price_quantity | currency }}
							</template>
							<template v-else>
								{{ product.total_price_quantity | currency }}
							</template>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth', 'data'],
		data () {
			return {
				modal: {
					selector: 'modal-product-detail'
				},

				product: null,
			}
		},
		methods: {
			open(product) {
				if(product) {
					this.product = product
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Detail.vue